import { CodeError } from '@iotize/common/error';
import { TapResponseStatusError } from '@iotize/tap';
import { TapBundle } from './target-variable/tap-bundle/tap-bundle';
import { TapVariable } from './target-variable/tap-variable/tap-variable';
import {
  EditableValueDataStreamInterface,
  KeyTypeType,
} from './utility/editable-data-stream';

export class TapDataError extends CodeError<TapDataError.Code> {
  constructor(
    msg: string,
    code: TapDataError.Code,
    public cause?: Error,
  ) {
    super(msg, code);
  }

  static unexpectedEncodedValueError(
    variable: EditableValueDataStreamInterface<any, any>,
    rawData: any,
    err: Error | any,
  ) {
    return new TapDataError(
      `An error occured while encoding value for variable ${variable.id}. ${err.message}`,
      TapDataError.Code.UnexpectedEncodedValueError,
    );
  }

  static unexpectedVariableDataRead(
    variable: EditableValueDataStreamInterface<any, any>,
    rawData: any,
    err: Error | any,
  ) {
    return new TapDataError(
      `An error occured while decoding value for variable ${variable.id}. ${err.message}`,
      TapDataError.Code.UnexpectedVariableData,
    );
  }

  static bundleNotFound<KeyType extends KeyTypeType>(key: KeyType) {
    return new TapDataError(
      `Bundle with identifier "${key.toString()}" is not registered`,
      TapDataError.Code.BundleNotFound,
    );
  }

  static variableNotFound<KeyType extends KeyTypeType>(key: KeyType) {
    return new TapDataError(
      `Variable with identifier "${key.toString()}" is not registered`,
      TapDataError.Code.VariableNotFound,
    );
  }

  static bundleNotConfigured(
    config: TapBundle.Config,
    err: TapResponseStatusError,
  ) {
    return new TapDataError(
      `Bundle with id "${config.id}" does not exist on this Tap. You should reconfigure your Tap to add this bundle.`,
      TapDataError.Code.BundleNotConfigured,
      err,
    );
  }

  static variableNotConfigured(
    config: TapVariable.Config,
    err: TapResponseStatusError,
  ) {
    return new TapDataError(
      `Variable with id "${config.id}" does not exist on this Tap. You should reconfigure your Tap to add this variable.`,
      TapDataError.Code.VariableNotConfigured,
      err,
    );
  }
}

export namespace TapDataError {
  export enum Code {
    UnexpectedVariableData = 'TapDataErrorUnexpectedVariableData',
    UnexpectedEncodedValueError = 'TapDataErrorUnexpectedEncodedValueError',
    BundleNotFound = 'TapDataErrorBundleNotFound',
    VariableNotFound = 'TapDataErrorVariableNotFound',
    BundleNotConfigured = 'TapDataErrorBundleNotConfigured',
    VariableNotConfigured = 'TapDataErrorVariableNotConfigured',
  }
}
